<template>
  <div style="text-align: center; padding: 30px">页面加载中...</div>
</template>
<script>
  import Cookies from 'js-cookie'
  export default {
    beforeCreate() {
      let uesrTag = Cookies.get("userTag")
      // 10供应商  20采购商
      if (uesrTag == 20) {
        this.$router.replace({ path:'/purchaseWorkBench'});
      } else if (uesrTag == 10) {
        this.$router.replace({ path:'/supplierWorkBench'});
      } else {
        this.$router.push({path:'/login'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/workBench/index.vue